import API from "../apis/api";
import { DepartmentInfo, GetDepartmentResponse } from "../apis/response/GetDepartmentResponse";
import { GetSubCatResponse, SubCategoryInfo } from "../apis/response/GetSubCatResponse";
import { TranslateField } from "../types/translate-field";
import { GetInfoResponse, ToTranslateField as translate } from "../apis/response/GetInfoResponse";

export class TranslationService {
    ConvertDepartmentName(data: DepartmentInfo): TranslateField {
        // return data.map(x => {
        return {
            key: data.dept_id,
            values: [
                { locale: 'en', value: data.dept_display_name },
                { locale: 'cn', value: data.dept_name_cns },
                { locale: 'zh', value: data.dept_name_cnt },
            ]
        }
        // })
    }
    ConvertDepartmentDesc(data: DepartmentInfo): TranslateField {
        // return data.map(x => {
        return {
            key: data.dept_id,
            values: [
                { locale: 'en', value: data.dept_desc_eng },
                { locale: 'cn', value: data.dept_desc_cns },
                { locale: 'zh', value: data.dept_desc_cnt },
            ]
        }
        // })
    }
    ConvertSubCatName(data: SubCategoryInfo): TranslateField {
        // return data.map(x => {
        return {
            key: data.sub_cat_id,
            values: [
                { locale: 'en', value: data.sub_cat_name_eng },
                { locale: 'cn', value: data.sub_cat_name_cns },
                { locale: 'zh', value: data.sub_cat_name_cnt },
            ]
        }
        // })
    }

    async TranslateDepartmentName(dept: string): Promise<TranslateField> {
        const res: GetDepartmentResponse = (await API.Category.GetDepartmentInfo(`${dept}`)).obj
        const info = res.items[0]
        return {
            key: info.dept_id,
            values: [
                { locale: 'en', value: info.dept_display_name },
                { locale: 'cn', value: info.dept_name_cns },
                { locale: 'zh', value: info.dept_name_cnt },
            ]
        }
    }

    async TranslateDepartmentDesc(dept: string): Promise<TranslateField> {
        const res: GetDepartmentResponse = (await API.Category.GetDepartmentInfo(`${dept}`)).obj
        const info = res.items[0]
        return {
            key: info.dept_id,
            values: [
                { locale: 'en', value: info.dept_desc_eng },
                { locale: 'cn', value: info.dept_desc_cns },
                { locale: 'zh', value: info.dept_desc_cnt },
            ]
        }
    }

    async TranslateSubCatName(subcat: string): Promise<TranslateField> {
        const res: GetSubCatResponse = (await API.Category.GetSubCatInfo(`${subcat}`)).obj
        const info = res.items[0]
        return {
            key: info.sub_cat_id,
            values: [
                { locale: 'en', value: info.sub_cat_name_eng },
                { locale: 'cn', value: info.sub_cat_name_cns },
                { locale: 'zh', value: info.sub_cat_name_cnt },
            ]
        }
    }

    GetFooterProps = async () => {
        const items: string[] = ['email_hk', 'phone_hk', 'fax_hk']
        let ver: TranslateField[] = []
        for ( const key of items ){
            const res: GetInfoResponse = (await API.Info.GetInfo(key)).obj[0]
            const f = translate(res)
            ver.push(f)
        }
        return ver
    }
}